// Provides `faqPageJsonldScript` — returns null when `article.faqItems` is empty,
// so consumers can `.filter(Boolean)` it out of the SEO scripts array.
import { safeJsonLd } from "@/utils/jsonldSafe";

export default {
  computed: {
    faqPageJsonldScript() {
      const faqs = this.article?.faqItems;
      if (!Array.isArray(faqs) || faqs.length === 0) return null;

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: { "@type": "Answer", text: f.answer },
        })),
      };

      return {
        hid: "jsonld-faqpage",
        type: "application/ld+json",
        innerHTML: safeJsonLd(schema),
      };
    },
  },
};
